import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        // Custom status variants
        pending: "border-transparent bg-amber-100 text-amber-800",
        confirmed: "border-transparent bg-sky-100 text-sky-800",
        inProgress: "border-transparent bg-violet-100 text-violet-800",
        completed: "border-transparent bg-emerald-100 text-emerald-800",
        cancelled: "border-transparent bg-slate-100 text-slate-600",
        noShow: "border-transparent bg-rose-100 text-rose-800",
        // Payment status variants
        paid: "border-transparent bg-emerald-100 text-emerald-800",
        unpaid: "border-transparent bg-amber-100 text-amber-800",
        failed: "border-transparent bg-rose-100 text-rose-800",
        refunded: "border-transparent bg-orange-100 text-orange-800",
        waived: "border-transparent bg-slate-100 text-slate-600",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
